import Login from "../views/Login.svelte";
import Shipment from "../views/shipment/Shipment.svelte";
import FinalInspection from "../views/finalInspection/FinalInspection.svelte";
import ProcessInspection from "../views/processInspection/ProcessInspection.svelte";
import ProcessNonconformity from "../views/processNonconformity/ProcessNonconformity.svelte";
import FinalNonconformity from "../views/finalNonconformity/FinalNonconformity.svelte";
import NotFound from "../views/NotFound.svelte";
import Temp from "../views/Temp.svelte";
import Menu from "../views/Menu.svelte";
import SupplyPlan from "../views/supplyPlan/SupplyPlan.svelte";
import SalesStatus from "../views/salesStatus/SalesStatus.svelte";

export default {
    "/": Login,
    "/Login": Login,
    "/Menu": Menu,
    "/Shipment": Shipment,
    "/FinalInspection": FinalInspection,
    "/ProcessInspection": ProcessInspection,
    "/ProcessNonconformity": ProcessNonconformity,
    "/FinalNonconformity": FinalNonconformity,
    "/SupplyPlan": SupplyPlan,
    "/SalesStatus": SalesStatus,
    // "/AsRepair/:as_id/:as_cmpn_id": AsRepair,
    "/Temp": Temp,
    "*": NotFound,
};
